// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__j8EO7","inner":"Form_inner__2gsuh","range":"Form_range__AKohl","name":"Form_name__330C7","actions":"Form_actions__3pqiP"};